import { render, staticRenderFns } from "./LatestPost.vue?vue&type=template&id=63df8881&scoped=true"
import script from "./LatestPost.vue?vue&type=script&lang=js"
export * from "./LatestPost.vue?vue&type=script&lang=js"
import style0 from "./LatestPost.vue?vue&type=style&index=0&id=63df8881&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df8881",
  null
  
)

export default component.exports